import { createStore } from 'vuex'

export default createStore({
  state: {
    user: {
      isLoggedIn: false,
      subscription: 'free', // free, premium, enterprise
      usage: {
        today: 0,
        limit: 1000
      }
    },
    voices: [],
    settings: {
      rate: 1,
      volume: 1,
      defaultVoice: null
    }
  },
  mutations: {
    SET_USER(state, user) {
      state.user = { ...state.user, ...user }
    },
    SET_VOICES(state, voices) {
      state.voices = voices
    },
    SET_SETTINGS(state, settings) {
      state.settings = { ...state.settings, ...settings }
    },
    INCREMENT_USAGE(state, count) {
      state.user.usage.today += count
    },
    RESET_DAILY_USAGE(state) {
      state.user.usage.today = 0
    }
  },
  actions: {
    login({ commit }, userData) {
      commit('SET_USER', { ...userData, isLoggedIn: true })
    },
    logout({ commit }) {
      commit('SET_USER', {
        isLoggedIn: false,
        subscription: 'free',
        usage: { today: 0, limit: 1000 }
      })
    },
    updateSubscription({ commit, state }, plan) {
      const newLimit = plan === 'free' ? 1000 : 
                      plan === 'premium' ? 10000 : 
                      Number.MAX_SAFE_INTEGER
      
      commit('SET_USER', {
        ...state.user,
        subscription: plan,
        usage: { ...state.user.usage, limit: newLimit }
      })
    },
    incrementUsage({ commit }, count) {
      commit('INCREMENT_USAGE', count)
    },
    resetDailyUsage({ commit }) {
      commit('RESET_DAILY_USAGE')
    }
  },
  getters: {
    remainingChars: state => {
      return state.user.usage.limit - state.user.usage.today
    },
    isNearLimit: state => {
      return state.user.usage.today > state.user.usage.limit * 0.8
    },
    isLimitReached: state => {
      return state.user.usage.today >= state.user.usage.limit
    }
  }
})